import { utils } from "../../../../shop/frontend/web/js/utils";
import { googleAnalytics } from "../../../../shop/frontend/web/js/components/googleAnalytics";
import { saveUtmToCookie } from "../../../../shop/frontend/web/js/utils/utm";
import { hamburger } from "../../../../shop/frontend/web/js/components/hamburger";
import { helpers } from "../../../../shop/frontend/web/js/helpers";

export class App {
	constructor() {
	}

	init(params = {}) {

		utils.addVoidForLinks($("a"));

		if (window.gaEnabled) googleAnalytics();
		saveUtmToCookie();

		this.initCheckUserByEmailInput();

		this.setUpListeners();
	}

	setUpListeners() {
		$(".enter form").on("submit", e => {
			const form = $(e.currentTarget);
			form.find("button[type='submit']").addClass("disabled");
		});

		$(".enter__input ").on("input", () => {
			$(".enter form button[type='submit']").removeClass("disabled");
		});

		$(".checkbox__input").on("keydown", e => {
			const element = $(e.currentTarget);

			if (e.code === "Enter" || e.code === "NumpadEnter") {
				element.toggleClass("checked");

				if ($(element).hasClass("checked")) {
					$(element).prop("checked", true);
				} else {
					$(element).prop("checked", false);
				}
			}
		});

		$(".hamburger").on("click", () => {
			$(".js-mobile-menu").slideDown();
		})

		$(".js-mobile-menu .close-menu").on("click", () => {
			$(".js-mobile-menu").slideUp();
		})

		$(document).on("click", ".js-enter-visible-password", e => {
			const element = $(e.currentTarget);
			const input = element.parents(".enter__block").find(".enter__input");
			element.toggleClass("active");

			if (input.attr("type") === "text") {
				input.attr("type", "password");
				element.attr(
					"aria-label",
					"Show password as plain text. " +
						"Warning: this will display your password on the screen."
				);
			} else {
				input.attr("type", "text");
				element.attr("aria-label", "Hide password.");
			}
		});

		$.each($(".form-group input"), (i, item) => {
			const element = $(item);
			if (element.val()) {
				element.next().addClass("inactive");
			}
		});

		$(".form-group input").on("input", e => {
			const element = $(e.currentTarget);
			element.next().addClass("inactive");
			if (!element.val()) {
				element.next().removeClass("inactive");
			}
		});

		$(".form-group input").on("click", e => {
			const element = $(e.currentTarget);
			element.next().addClass("inactive");
		});

		$(".form-group input").on("blur", e => {
			const element = $(e.currentTarget);
			if (!element.val()) {
				element.next().removeClass("inactive");
			}
		});

		$('.checkbox_register input[type="checkbox"]').on("change", e => {
			const $element = $(e.currentTarget);
			const value = Number($element.val());
			if (value === 1) {
				$element.prev().val(0);
				$element.val(0);
			} else {
				$element.prev().val(1);
				$element.val(1);
				$(".js-fast-btn").removeClass("disabled");
			}
		});
	}

	setUpModalListeners() {
		$("#js-common-modal-close").on("click", () => {
			if (window.location.pathname.includes("event")) {
				window.location.assign("/");
			}
		});

		$(document).on("click", ".enter__close", () => {
			if (window.location.pathname.includes("event") && !helpers.isDesktop.matches) {
				window.location.assign("/");
			}
		});

		$(".js-enter-recovery").on("click", () => {
			$("#loginModal").modal("hide");
		});

		$(document).on("click", ".js-login-back", () => {
			$("#recoveryModal").modal("hide");
			$("#loginModal").modal("show");
		});

		$(".js-enter-register").on("click", () => {
			$("#loginModal").modal("hide");
			$("#accessModal").modal("hide");
		});

		$(".js-enter-login").on("click", () => {
			$("#registerModal").modal("hide");
			$("#fastRegisterModal").modal("hide");
			$("#accessModal").modal("hide");
			$("#js-popup-modal").modal("hide");
		});
	}

	initCheckUserByEmailInput() {
		$(".js-input-email-fast").on("change", e => {
			const element = $(e.currentTarget);
			const email = element.val();
			api.user.check({ email }).then(user => {
				const form = element.parents("form");
				const second = form.find(".js-fast-second")[0];
				const first = form.find(".js-fast-first")[0];
				const phone = form.find(".js-fast-phone")[0];
				second.value = user.second;
				first.value = user.first;
				phone.value = user.phone;
			});
		});
	}
}
